export enum EmailEditingSteps {
	chooseTemplate = 'chooseTemplate',
	editTemplate = 'editTemplate',
}

export enum ButtonColorTypes {
	default = 'default',
	client = 'client',
	custom = 'custom',
}

export enum EmailLetterTypes {
	INVITATION = 'INVITATION',
	REMINDER = 'REMINDER',
}

export enum EmailTemplateTypes {
	STANDARD = 'STANDARD',
	SIMPLE = 'SIMPLE',
}

export interface IEmailEditingType {
	email: EmailLetterTypes;
	template: EmailTemplateTypes;
}
